import styled from '@emotion/styled'
import MotionFlex from '../../utils/MotionFlex'

export const RenderWrapper = styled(MotionFlex)`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  flex-direction: column;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
`

export const MenuCont = styled(MotionFlex)`
  flex: 0 0 232px;
  position: fixed;
  max-width: 100%;
  min-height: 100vh;
  width: 232px;
  z-index: 1299;
  overflow: visible;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.04);
  & .sidebar-menu-icon {
    font-size: 16px;
    flex-shrink: 0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  & .nav-link-text-hidden > div > span {
    opacity: 0;
    visibility: hidden;
    width: 0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
`

export const MenuCont2 = styled(MotionFlex)`
  position: fixed;
  max-width: 100%;
  height: 100vh;
  z-index: 1299;
  right: 0;
  border-left: 1px solid #eaeaea;

  & .sidebar-menu-icon {
    font-size: 16px;
    margin-left: 20px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  & .nav-link-text-hidden > div > span {
    opacity: 0;
    visibility: hidden;
    width: 0;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
`

export const Overlay = styled(MotionFlex)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1295;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
`
